(function ($) {
    $("#gp-ajax-form--newsletter_with_name").on("submit_success", function(){
        $(this).trigger("reset")
    })
})(jQuery);
